import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ children, allowedUserType }) => {
  const { user, userType, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-8 h-8 border-4 border-primary-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    // Redirect to appropriate login page
    const loginPath =
      allowedUserType === "admin" ? "/admin-login" : "/client-login";
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  if (allowedUserType && userType !== allowedUserType) {
    // User is logged in but with wrong type
    const dashboardPath =
      userType === "admin" ? "/admin/dashboard" : "/client/dashboard";
    return <Navigate to={dashboardPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
